import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Programmers are born not made",
  "description": "",
  "published": "2012-01-05T00:00:00.000Z",
  "redirect_from": ["/blog/programmers-are-born-not-made/swizec/3369"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Programmers are a special breed, `}<em parentName="p">{`good`}</em>{` `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Programmer",
        "title": "Programmer"
      }}>{`programmers`}</a>{` especially - our craft is more an art than we like to admit when trying to wrestle it into a Hard Engineering Discipline (tm). It's actually more like mathematics, music or the wizardry Kaylee does in `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Firefly_%28TV_series%29",
        "title": "Firefly (TV series)"
      }}>{`Firefly`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/Passion_cover3.jpg",
        "alt": "Passion (novel)",
        "title": "Passion (novel)"
      }}></img></p>
    <p>{`Good programmers have a special feel, a talent that is difficult to explain and even harder to attain.`}</p>
    <p>{`A few weeks ago `}<a parentName="p" {...{
        "href": "https://twitter.com/#!/zidarsk8"
      }}>{`@zidarsk8`}</a>{` came rushing to me `}<em parentName="p">{`"Dude! There's this guy! I've been teaching him coding! He's already better than me! Hasn't even heard of a variable before a month ago! It's so frikkin' awesome!"`}</em></p>
    <p>{`He made me promise to blog about it. Why is it some people just `}<em parentName="p">{`get`}</em>{` it? What's so special about them? Can anybody be taught to program or does it really take a special breed to become even a competent programmer, let alone a good one?`}</p>
    <p>{`I remember tutoring a high school kid about a year ago. About to fail his `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Computer_programming",
        "title": "Computer programming"
      }}>{`programming`}</a>{` class (CE high school, we have those), he came running to me. In a month I was to teach him everything I know, or at least enough to pass the class.`}</p>
    <p>{`Come end of the month and he knew everything about loops, variable assignment, even understood that functions are packets of code that can do stuff. My parting words to his father were `}<em parentName="p">{`"Yeah, he knows everything. Just needs a bit of practice to get it."`}</em></p>
    <p>{`I doubt he ever passed the class. Or if he did it was the teacher's mercy ... and that teacher isn't very merciful from what I remember of her in my high school times.But this isn't just because I'm a bad teacher - others came to me after that one kid on his recommendation and I got a `}<em parentName="p">{`"Thank you! I bloody passed! yay!"`}</em>{` email from all of them - there are people who simply aren't programmers. Never `}<em parentName="p">{`will`}</em>{` be programmers. Not even mediocre ones.`}</p>
    <h2 {...{
      "id": "the-non-programming-sheep"
    }}>{`The non-programming sheep`}</h2>
    <p><a parentName="p" {...{
        "href": "http://www.codinghorror.com/",
        "title": "Jeff Atwood"
      }}>{`Jeff Atwood`}</a>{` wrote about `}{`_`}<a parentName="p" {...{
        "href": "http://www.codinghorror.com/blog/2006/07/separating-programming-sheep-from-non-programming-goats.html"
      }}>{`Separating Programming Sheep from Non-Programming Goats`}</a>{`_`}{`in 2006 where he mentions a study that claims to have found a test to predict future programming ability.The test is really simple:`}</p>
    <p>{`a = 5
b = 20
a = b`}</p>
    <p>{`What are a and be now?`}</p>
    <p>{`And some more questions like that. Only `}<strong parentName="p">{`44%`}</strong>{` of the students formed a consistent `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Mental_model",
        "title": "Mental model"
      }}>{`mental model`}</a>{` of assignment - even a wrong one. The rest failed or didn't answer the questions.`}</p>
    <p>{`Worse still, after a semester of learning to program, the numbers were the same. Only 44% of the students understood how assignment works.`}</p>
    <p>{`Some people just dont `}<em parentName="p">{`get`}</em>{` it. Apparently.`}</p>
    <p>{`But I think there's an even simpler test ->`}</p>
    <h2 {...{
      "id": "passion"
    }}>{`Passion.`}</h2>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/300px-Sheep1.jpg",
        "alt": "Sheep",
        "title": "Sheep"
      }}></img></p>
    <p>{`Sometimes when you give an impressionable young mind (anybody deciding to learn to code, age is irrelevant) two tools and a problem, they will use the two tools to create four more tools. Then they will get on the internets and find some more tools ... soon they have twenty tools and what was the problem you wanted me to solve again?`}</p>
    <p>{`That's passion!`}</p>
    <p>{`Pure unadulterated passion for programming. When you can be fascinated, even excited, about this stuff without a need to solve a problem. Hell, even if you `}<em parentName="p">{`are`}</em>{` solving a problem that you know is a meaningless exercise ... that's where greatness lies.`}</p>
    <p>{`It doesn't matter what age you started coding at - many studies have shown experience is not a predictor of quality in our world - what matters is that you have a passion for this stuff.`}</p>
    <p>{`Because if you've got the passion, then you probably have everything else you need as well.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/programmers-are-fucking-lazy/swizec/2648"
        }}>{`Programmers are fucking lazy`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://bob-roberts.net/2012/01/01/becoming-a-better-developer/"
        }}>{`Becoming a better Developer`}</a>{` (bob-roberts.net)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://jaredcosulich.wordpress.com/2011/12/11/programmer-the-best-profession/"
        }}>{`Programmer - The Best Professsion?`}</a>{` (jaredcosulich.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://bob-roberts.net/2011/11/06/whats-in-a-name-programmer-or-developer/"
        }}>{`What's in a name? Programmer or Developer`}</a>{` (bob-roberts.net)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://news.ycombinator.com/item?id=3032943"
        }}>{`Today a programmer was born. And you are my mother.`}</a>{` (news.ycombinator.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=8bbc9c9d-90c1-4e04-9492-66f28a485b8b",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      